/**
 * Dynamic permission codes aligned with backend enum names (UserPermission / CompanyPermission).
 *
 * Any property you read returns the same string key, so you can write
 *   hasUserPermission(UserPermission.MY_NEW_FLAG)
 * without ever updating a central list when the backend adds a new permission.
 *
 * For company-only flags use CompanyPermission the same way.
 *
 * You can also pass plain strings: hasUserPermission('MY_NEW_FLAG').
 *
 * Do not rely on Object.keys(UserPermission) — it is empty. Admin UIs load labels from the API.
 */
function createPermissionNamespace() {
    return new Proxy(
        {},
        {
            get(_target, prop) {
                if (typeof prop !== 'string') {
                    return undefined;
                }
                // Avoid accidental Promise-like behavior if the object is mistaken for a thenable
                if (prop === 'then') {
                    return undefined;
                }
                return prop;
            },
        }
    );
}

/** @type {Record<string, string>} */
export const UserPermission = createPermissionNamespace();

/** @type {Record<string, string>} */
export const CompanyPermission = createPermissionNamespace();
